import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../common/Loader";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isValidating, loading } = useSelector(
    (state) => state.auth
  );
  const location = useLocation();

  // Check if user has a token in storage
  const hasTokenInStorage = () => {
    if (localStorage.rememberMe === "true") {
      return !!localStorage.token;
    }
    return !!sessionStorage.token;
  };

  // Priority 1: If user is authenticated (token validated), allow access immediately
  if (isAuthenticated) {
    return children;
  }

  // Priority 2: If we have a token, allow access (validation happens in background)
  // This prevents blank screen - if token is invalid, AuthValidator/axios interceptor will redirect
  // We trust that if a token exists, the user should be able to access the page
  // AuthValidator will validate in the background and redirect if needed
  if (hasTokenInStorage()) {
    // Allow component to render - AuthValidator will handle validation and redirect if needed
    return children;
  }

  // Priority 3: No token in storage - redirect to login
  // Store the attempted location in sessionStorage so we can redirect back after login
  sessionStorage.setItem(
    "redirectAfterLogin",
    location.pathname + location.search
  );
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
